// Общие window-события приложения
export const WALLET_UPDATED_EVENT = 'wallet-updated';
export const FILTERS_UPDATED_EVENT = 'filters-updated';
